import React from "react"
import { Link } from "gatsby"

export default props => (
    <li className="list-link-item">
        <Link to={props.to} className="list-link">{props.children}</Link>
    </li>
)